<div class="meal-snack-content">
    <div class="meal-row" [ngClass]="{ 'attention': mealAttention }">
        <label class="lbl">{{ mealValue }}</label>
    </div>
    <div class="snack-row" [ngClass]="{ 'attention': snackAttention }">
        <label class="lbl">{{ snackValue }}</label>
    </div>
</div>
